import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Button,
  useToast,
} from '@chakra-ui/react'
import React from 'react'
import { api } from '../../../services/api'
import { useMutation, useQueryClient } from 'react-query'

async function confirmarValidacaoNf({ id }) {
  const res = await api.put('/site/v2/fiscal/confirmar-validacao-nf', {
    id,
  })

  return res.data
}

export function ConfirmarValidacaoDeNf({ id }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()
  const toast = useToast({
    position: 'top-right',
    duration: 5000,
  })

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: confirmarValidacaoNf,
    onSuccess: () => {
      toast({
        title: 'NF validada com sucesso!',
        status: 'success',
      })

      queryClient.invalidateQueries('nfData')

      onClose()
    },
    onError: () => {
      toast({
        title: 'Erro ao validar NF',
        status: 'error',
      })
    },
  })

  async function handleConfirmar() {
    await mutateAsync({ id: id }) // id da NF
  }

  return (
    <>
      <Button size="xs" colorScheme="green" onClick={onOpen}>
        Confirmar
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirmar validação de NF
            </AlertDialogHeader>

            <AlertDialogBody>Tem certeza que deseja confirmar a validação desta NF?</AlertDialogBody>

            <AlertDialogFooter>
              <Button colorScheme="red" ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="green" ml={3} isLoading={isLoading} onClick={handleConfirmar}>
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
